<kui-modal #modal [loading]="loading" [title]="'ADMIN.MODALS.DASHBOARD.TITLE' | translate: { title: data.title }" [actions]="modalActions" size="fill" (onClose)="detachModal()">
    @if (widgets) {
        <key-dashboard
            [id]="data?.id"
            [widgets]="widgets"
            [useSampleData]="data?.useSampleData"
            [showShare]="false"
            [isDashboardTemplate]="data?.isDashboardTemplate"
            (onUpdateWidgetsPlacement)="updateWidgetsPlacement($event)"
            (onUpdateWidget)="updateWidget($event)"
            (onRemoveWidget)="removeWidget($event)"
        ></key-dashboard>
    }
</kui-modal>
